import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=965fed1c&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=ts&"
export * from "./CaseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=965fed1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fed1c",
  null
  
)

export default component.exports